const state = {
   company: null,
   companyBuildingDefinition: null,
   enableDynamicPayment: false,
}
const getters = {
   company: state => state.company,
   enableDynamicPayment: state => state.enableDynamicPayment,
   companyId: state => state.company._id,
   companyBuildingDefinition: state =>
      Array.isArray(state.companyBuildingDefinition)
         ? state.companyBuildingDefinition[0]
         : state.companyBuildingDefinition,
}
const mutations = {
   enableDynamicPayment(state, payload) {
      console.log("enableDynamicPayment", payload);
      state.enableDynamicPayment = payload
   },
   company(state, payload) {
      state.company = payload
   },
   companyBuildingDefinition(state, payload) {
      state.companyBuildingDefinition = payload
   },
}
const actions = {
   setCompany({ commit, state }, company) {
      if (company.strings) {
         commit(
            'companyBuildingDefinition',
            Array.isArray(company.strings)
               ? company.strings[0]
               : company.strings
         )
      }
      commit('company', company)
   },
   setDynamicPayment({ commit, state }, enableDynamicPayment) {
      commit('enableDynamicPayment', enableDynamicPayment)
   },
   setcompanyBuildingDefinition({ commit, state }, companyBuildingDefinition) {
      commit('companyBuildingDefinition', companyBuildingDefinition)
   },
}

export default {
   actions,
   state,
   getters,
   mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/company.js